import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { Button, Input } from '@follow/ui';

import Navbar from '../../components/Navbar/Navbar';
import AssetsService from '../../services/AssetsService';

const SiteCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [name, setName] = useState('');
  const [addressStreet, setAddressStreet] = useState('');
  const [addressPostalCode, setAddressPostalCode] = useState('');
  const [addressCity, setAddressCity] = useState('');

  const isValid = name.trim() && addressStreet.trim() && addressPostalCode.trim() && addressCity.trim();

  const createLocationMutation = useMutation({
    mutationFn: () =>
      AssetsService.createLocation({
        name: name.trim(),
        addressStreet: addressStreet.trim(),
        addressPostalCode: addressPostalCode.trim(),
        addressCity: addressCity.trim(),
        schedules: [],
      }),
    onSuccess: (data) => {
      toast.success('Site créé');
      queryClient.invalidateQueries({ queryKey: ['locations'] });
      navigate(`/site/${data.location.id}`);
    },
    onError: () => {
      toast.error('Erreur lors de la création du site');
    },
  });

  const handleCreate = () => {
    if (!isValid) return;
    createLocationMutation.mutate();
  };

  return (
    <div className="flex flex-col h-screen bg-off-white">
      <Navbar
        breadcrumbs={[
          { label: 'Sites', href: '/sites' },
          { label: 'Nouveau site' },
        ]}
      />
      <div className="self-stretch flex-1 inline-flex justify-center items-start">
        <div className="flex-1 self-stretch pt-16 inline-flex flex-col justify-start items-center gap-8 overflow-auto">
          <div className="w-full max-w-[640px] px-4 flex flex-col justify-start items-start gap-8">
            <div className="self-stretch inline-flex justify-start items-start gap-4">
              <div className="flex-1 inline-flex flex-col justify-center items-start">
                <h1 className="text-neutral typo-h1">Nouveau site</h1>
              </div>
            </div>
          </div>
          <div className="w-full max-w-[640px] px-4 flex flex-col justify-start items-start gap-4">
            <h2 className="text-neutral typo-h2">Détails</h2>
            <div className="self-stretch p-4 bg-white rounded-lg shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10 flex flex-col justify-center items-start gap-6 overflow-hidden">
              <div className="w-full max-w-[480px] flex flex-col justify-start items-start gap-1">
                <label className="self-stretch text-neutral-80 typo-label">
                  Nom du site
                </label>
                <Input
                  tone="dark"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="w-full max-w-[480px] flex flex-col justify-start items-start gap-1">
                <label className="self-stretch text-neutral-80 typo-label">
                  Adresse
                </label>
                <Input
                  tone="dark"
                  type="text"
                  value={addressStreet}
                  onChange={(e) => setAddressStreet(e.target.value)}
                />
              </div>
              <div className="w-full max-w-[480px] flex gap-4">
                <div className="flex-1 flex flex-col justify-start items-start gap-1">
                  <label className="self-stretch text-neutral-80 typo-label">
                    Code postal
                  </label>
                  <Input
                    tone="dark"
                    type="text"
                    value={addressPostalCode}
                    onChange={(e) => setAddressPostalCode(e.target.value)}
                  />
                </div>
                <div className="flex-1 flex flex-col justify-start items-start gap-1">
                  <label className="self-stretch text-neutral-80 typo-label">
                    Ville
                  </label>
                  <Input
                    tone="dark"
                    type="text"
                    value={addressCity}
                    onChange={(e) => setAddressCity(e.target.value)}
                  />
                </div>
              </div>
              <div className="self-stretch inline-flex justify-end items-start gap-2">
                <Button variant="outline" size="sm" onClick={() => navigate('/sites')}>
                  Annuler
                </Button>
                <Button
                  variant="primary"
                  tone="light"
                  size="sm"
                  onClick={handleCreate}
                  disabled={!isValid}
                  loading={createLocationMutation.isPending}
                >
                  Créer
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteCreate;
